import { useNavigate } from "react-router-dom"
import { PasswordChange } from "./PasswordChange"
import Dialog from "@hydrologiq/shared/chakra/Dialog"

/**
 * PasswordChangeDialog - Wrapper component that renders PasswordChange in a fullscreen dialog
 * Used as a nested route within Dashboard to prevent section reloads
 */
export const PasswordChangeDialog = () => {
  const navigate = useNavigate()

  const handleClose = () => {
    navigate("/")
  }

  return (
    <Dialog open={true} onClose={handleClose} title="Change Password">
      <PasswordChange />
    </Dialog>
  )
}
